import { Box, Tooltip } from "@mui/material";

export default function ProfileAvatar({ name = "", surname = "" }) {
  const initials = `${name?.charAt(0) || ""}${
    surname?.charAt(0) || ""
  }`.toUpperCase();
  const fullName = `${name} ${surname}`.trim();

  const bgColor = getColorFromName(name, surname);

  return (
    <Tooltip title={fullName} arrow>
      <Box
        sx={{
          backgroundColor: bgColor,
          width: 36,
          height: 36,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontWeight: 700,
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        {initials}
      </Box>
    </Tooltip>
  );
}

const COLORS = [
  "#1abc9c",
  "#2ecc71",
  "#3498db",
  "#9b59b6",
  "#e67e22",
  "#e74c3c",
  "#16a085",
  "#27ae60",
  "#2980b9",
  "#8e44ad",
  "#f39c12",
  "#d35400",
];

function getColorFromName(name, surname) {
  const str = `${name}${surname}`;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}
